import { ReactNode } from "react";

export enum ProjectSetupType {
  Template = "template",
  BasedOnExistingProject = "existingProjectStructure",
  Blank = "blank",
}

type SelectOption = { label: string; value: string };

type ProjectSetupOption = {
  value:
    | ProjectSetupType.Template
    | ProjectSetupType.BasedOnExistingProject
    | ProjectSetupType.Blank;
  label: string;
  customElement: ReactNode;
};

type ProjectAction = "create" | "activate";

export interface ProjectMetafield {
  wsGlobalProjectMetaFieldUuid: string;
  value: any;
}

export type { SelectOption, ProjectSetupOption, ProjectAction };
